<template>
  <div id="app">
    <el-container>
      <el-header height="100px">
        <div  class="header">
          <div style="height: 100px;display: flex;align-items: center;">
            <img src="./assets/logo.png" style="width: 70px;height: 70px;" alt="">
          </div>
          <el-menu
            :default-active="activeMenu"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#333333"
            active-text-color="#FFF7EA"
            style="height: 100px"
            router
          >
            <el-menu-item index="/" style="height: 100px; line-height: 100px"
              >首页</el-menu-item
            >
            <el-menu-item
              index="/synopsis"
              style="height: 100px; line-height: 100px"
              >公司简介</el-menu-item
            >
            <el-menu-item index="/sell" style="height: 100px; line-height: 100px"
              >卖书答疑</el-menu-item
            >
            <el-menu-item index="/buy" style="height: 100px; line-height: 100px"
              >买书答疑</el-menu-item
            >
            <el-menu-item index="/user" style="height: 100px; line-height: 100px"
              >用户协议</el-menu-item
            >
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div id="footer_app">
          <div style="width: 100%">
            <div id="footer_tips">
              让 / 您 / 的 / 图 / 书 / 在 / 几 / 世 / 轮 / 回 / 中 / 得 / 到 /
              应 / 有 / 的 / 礼 / 遇
            </div>
            <div id="footer_body">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <div id="foot_ercode">
                  <div
                    style="width: 100%; height: 100%; background-color: #FFFFFF"
                  >
                  <img :src="config.website_wxcode" style="width: 100%; height: 100%;" alt="">
                </div>
                </div>
                <span style="color: #fff7ea; font-size: 24px; font-weight: 500"
                  >公众号</span
                >
              </div>
              <div id="foot_word">
                <div class="foot_word_model">
                  <div class="foot_word_model_title">联系我们</div>
                  <div class="foot_word_model_cell">客服电话：{{config.website_phone}}</div>
                  <div class="foot_word_model_cell">客服微信：{{config.website_wx}}</div>
                  <div class="foot_word_model_cell">客服QQ：{{config.website_qq}}</div>
                </div>
                <div class="foot_word_model" style="margin-left: 178px;">
                  <div class="foot_word_model_title">地址</div>
                  <div class="foot_word_model_cell">
                    {{config.website_address}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="foot_copyright">
            {{linkUrl}} <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2024136751号-1</a>
          </div>
          <!-- Copyright (C)循卷Y 2018-2019 All Rights Reserved
            湘ICP备19001160号-1 出版物经营许可证 新出发岳文字第430104201800093号 -->
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    // 动态绑定当前路由路径
    activeMenu() {
      return this.$route.path;
    },
  },
  data(){
    return {
      config:{},
      linkUrl:'',
    };
  },
  methods:{
    sysConfig() {
      this.$postRequest("/sysConfig",{
        keys:[
            "website_wxcode",
            "website_phone",
            "website_wx",
            "website_qq",
            "website_address"
        ]
      }).then((res) => {
        this.config = res.data;
      });
    },
    gettime(){
      var myDate = new Date();
      this.linkUrl = `Copyright © 2024~${myDate.getFullYear()} 版权所有`
    }
  },
  created(){
    this.sysConfig();
    this.gettime();
  }
};
</script>

<style>
.foot_word_model{
  text-align: left;
  min-width: 30%;
}
.foot_word_model_cell {
  font-size: 18px;
  color: #fff7ea;
  margin-bottom: 12px;
}
.foot_word_model_title {
  font-size: 25px;
  font-weight: 500;
  color: #fff7ea;
  margin-bottom: 20px;
  margin-top: 16px;
}
#footer_body {
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#foot_ercode {
  width: 202px;
  height: 202px;
  padding: 20px;
  box-sizing: border-box;
}
#foot_word {
  width: calc(100% - 260px);
  height: 202px;
  display: flex;
}
#foot_copyright {
  width: 100%;
  height: 78px;
  border-top: 1px solid #dbdbdb;
  text-align: center;
  line-height: 78px;
  color: #fff7ea;
  font-size: 20px;
}
#foot_copyright a{
  line-height: 78px;
  color: #fff7ea;
  font-size: 20px;
  text-decoration: none;
}
#footer_tips {
  max-width: 1400px;
  height: 79px;
  box-sizing: border-box;
  border: 2px solid #fff7ea;
  font-size: 25px;
  font-weight: 500;
  line-height: 79px;
  color: #fff7ea;
  letter-spacing: 5px;
  margin: 0px auto;
}
#footer_app {
  width: 100%;
  height: 504px;
  background: #698c6c;
  padding-top: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
.el-header {
  padding: 0px !important;
}
.el-main {
  padding: 0px !important;
}
.el-footer {
  padding: 0px !important;
}
/* 取消选中菜单项的底部边框 */
.el-menu-item.is-active {
  border-bottom: none !important;
}
.el-menu-item {
  font-size: 20px !important;
}
/* 更改选中菜单项的背景颜色 */
.el-menu-item.is-active {
  background-color: #698c6c !important; /* 使用 Element UI 的主题色 */
  color: white !important; /* 更改文字颜色 */
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
body {
  padding: 0px;
  margin: 0px;
}
</style>
<style lang="scss" scoped>
.header {
  width: 100vw;
  padding: 0px 250px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  position: fixed;
  left: 0;
  top: 0;
}
</style>
